import { teamComponentMaps } from "./teamComponentMaps"

/**
 * Deduce the team and component from the pathname using a map file for each team
 */
export const getTeamComponentFromPath = (pathname: string, team: 'cp' | 'crm' | 'sourcing') => {
  const teamComponentMap = teamComponentMaps[team]

  // remove query parameters if any
  const pathWithoutQuery = pathname.split('?')[0];

  // find the first matching pattern
  for (const { pattern, team, component } of teamComponentMap) {
    const patternRegex = new RegExp(
      "^" + pattern.replace(/\*/g, ".*") + "$"
    )

    if (patternRegex.test(pathWithoutQuery)) {
      return {
        team,
        component
      }
    }
  }

  // default if no match is found
  return { team, component: "other" }
}
